var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"external-iframe",domProps:{"innerHTML":_vm._s(_vm.EventDetail.iframe)}})
}
var staticRenderFns = []

export { render, staticRenderFns }